
export class Credentials
{
    AppName = "SpecteamOrders";
    Password = "";

    constructor(password: string)
    {
        this.Password = password;
    }
}
